<script setup lang="ts">
import NetworkBadge from '@/components/ui/NetworkBadge.vue';
import type { Group } from '@/@types/group';

defineProps<{
  group: Group;
}>();
</script>

<template>
  <button class="group-item" type="button">
    <span class="group-item__color" :style="{ backgroundColor: group.color || '#00B871' }" />
    <!-- The row is named by the network name alone: the badge only decorates it. -->
    <NetworkBadge
      aria-hidden="true"
      class="group-item__logo"
      :name="group.name"
      :color="group.color"
      :logo-url="group.logo_url"
    />
    <span class="group-item__name">{{ group.name }}</span>
  </button>
</template>

<style lang="scss" scoped>
.group-item {
  align-items: center;
  background-color: $color-white;
  border: 0;
  border-radius: $radius-2xl;
  cursor: pointer;
  display: flex;
  gap: $spacing-3;
  padding: $spacing-4 $spacing-3 $spacing-4 $spacing-4;
  text-align: left;
  width: 100%;

  &:active {
    background-color: $color-neutral-low;
  }

  &__color {
    border-radius: $radius-pill;
    flex-shrink: 0;
    height: 28px;
    width: 4px;
  }

  &__logo {
    --network-badge-height: 28px;
  }

  &__name {
    color: $color-neutral-highest;
    flex: 1;
    font: $label-medium;
    letter-spacing: $label-medium-spacing;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
